import type { Theme } from '@goodtime/engine';
import { buildSlotAssets } from './slotAssets';

const ASSETS = buildSlotAssets('aurora', {
  cherry: 'snow_lantern',
  lemon: 'crescent_moon',
  orange: 'campfire',
  bell: 'wind_chime',
  star: 'aurora_wild',
  seven: 'north_star',
  gem: 'violet_gem',
  scatter: 'shooting_star_scatter',
  money: 'sky_hoard',
});

/** Aurora — GENERATED by scaffoldSlot from
 *  content/slots/aurora.slot.json.
 *  Edit the spec and regenerate rather than hand-editing this file
 *  (hand edits are overwritten on the next scaffold run). */
export const AURORA_THEME: Theme = {
  id: 'aurora',
  name: 'Aurora',
  palette: {
    accent: 0x8e6fd0,
    secondary: 0x6fd0c0,
    warm: 0xf2d27a,
    frameFill: 0x14122b,
    bgGradientTop: 0x2a2150,
    bgGradientBottom: 0x0b0a1a,
    dimOverlay: 0x060512,
  },
  slot: {
    symbols: [
      { id: 'cherry', label: 'Snow Lantern', glyph: '🏮', tint: 0xe0a83a, weight: 5, textureAlias: 'aurora:cherry',
        winVideoAlias: 'aurora:cherry:win:video', winVideoSpeed: 2 },
      { id: 'lemon', label: 'Crescent Moon', glyph: '🌙', tint: 0xe8dca0, weight: 5, textureAlias: 'aurora:lemon',
        winVideoAlias: 'aurora:lemon:win:video', winVideoSpeed: 2 },
      { id: 'orange', label: 'Campfire', glyph: '🔥', tint: 0xe06a2a, weight: 4, textureAlias: 'aurora:orange',
        winVideoAlias: 'aurora:orange:win:video', winVideoSpeed: 2 },
      { id: 'bell', label: 'Wind Chimes', glyph: '🎐', tint: 0xc8d6e0, weight: 3, textureAlias: 'aurora:bell',
        winVideoAlias: 'aurora:bell:win:video', winVideoSpeed: 2 },
      { id: 'star', label: 'Aurora', glyph: '🌌', tint: 0x9a8fe0, weight: 2, textureAlias: 'aurora:star',
        winVideoAlias: 'aurora:star:win:video', winVideoSpeed: 2 },
      { id: 'seven', label: 'North Star', glyph: '⭐', tint: 0xf0e4a0, weight: 2, textureAlias: 'aurora:seven',
        winVideoAlias: 'aurora:seven:win:video', winVideoSpeed: 2 },
      { id: 'gem', label: 'Violet Gem', glyph: '🔮', tint: 0x9a6fd0, weight: 2.5, textureAlias: 'aurora:gem',
        winVideoAlias: 'aurora:gem:win:video', winVideoSpeed: 2 },
      { id: 'scatter', label: 'Shooting Star', glyph: '🌠', tint: 0xe8dca0, weight: 0.5, textureAlias: 'aurora:scatter',
        winVideoAlias: 'aurora:scatter:win:video', winVideoSpeed: 2 },
      { id: 'money', label: 'Sky Hoard', glyph: '💰', tint: 0xf0c860, weight: 1, textureAlias: 'aurora:money',
        winVideoAlias: 'aurora:money:win:video', winVideoSpeed: 2, isMoney: true },
      // Gem-on-reel — producer brief 2026-06-04. Scatter-style bonus
      // shared across every biome (registered via SHARED_REEL_SYMBOLS
      // in themes/index.ts). Weights deliberately rare so a gem
      // landing feels like a treat rather than background noise.
      { id: 'gem_t5',  label: 'Gems',     glyph: '💎', tint: 0x3ea7e8, weight: 0.10, gemValue: 5,  textureAlias: 'shared:reel:gem_5' },
      { id: 'gem_t10', label: 'Gem Pile', glyph: '💎', tint: 0x3ea7e8, weight: 0.05, gemValue: 10, textureAlias: 'shared:reel:gem_10' },
    ],
    wildSymbolId: 'star',
    scatterSymbolId: 'scatter',
  },
  wheel: {
    segments: [
      { id: 'x1-a', kind: 'multiplier', label: '×1', tint: 0x8e6fd0, multiplier: 1, weight: 5 },
      { id: 'x2-a', kind: 'multiplier', label: '×2', tint: 0xf2d27a, multiplier: 2, weight: 4 },
      { id: 'x1-b', kind: 'multiplier', label: '×1', tint: 0x8e6fd0, multiplier: 1, weight: 5 },
      { id: 'x3-a', kind: 'multiplier', label: '×3', tint: 0x6fd0c0, multiplier: 3, weight: 3 },
      { id: 'x2-b', kind: 'multiplier', label: '×2', tint: 0xf2d27a, multiplier: 2, weight: 4 },
      { id: 'x1-c', kind: 'multiplier', label: '×1', tint: 0x8e6fd0, multiplier: 1, weight: 4 },
      { id: 'x5-a', kind: 'multiplier', label: '×5', tint: 0xf2d27a, multiplier: 5, weight: 2 },
      { id: 'x2-c', kind: 'multiplier', label: '×2', tint: 0xf2d27a, multiplier: 2, weight: 3 },
      { id: 'x3-b', kind: 'multiplier', label: '×3', tint: 0x6fd0c0, multiplier: 3, weight: 3 },
      { id: 'x1-d', kind: 'multiplier', label: '×1', tint: 0x8e6fd0, multiplier: 1, weight: 4 },
      { id: 'x5-b', kind: 'multiplier', label: '×5', tint: 0xf2d27a, multiplier: 5, weight: 2 },
      { id: 'x10-a', kind: 'multiplier', label: '×10', tint: 0xf2d27a, multiplier: 10, weight: 1 },
    ],
  },
  assets: {
    slot: ASSETS.slot,
    slotWin: ASSETS.slotWin,
    scene: {
      background: { alias: 'aurora:bg', path: 'environment/aurora.png' },
      columnBackground: { alias: 'aurora:column_bg', path: 'reel/aurora_column_bg.png' },
      border: { alias: 'aurora:border', path: 'brand/border_frost.png' },
    },
  },
};
